export function formatTweetText(text: string, generateLinks: boolean = true) {
  // Replace newlines with <br>
  const formattedText = text.replace(/\n/g, "<br>");

  const processedText = formattedText;

  // Track positions of entities to avoid overlapping replacements
  const entities: Array<{ start: number; end: number; replacement: string }> =
    [];

  // URLs - must be processed first to handle URLs with hashtags/mentions correctly
  // Match URLs that may contain hashtags, mentions, etc.
  const urlRegex = /https?:\/\/[^\s<>"']+/g;
  let match: RegExpExecArray | null;
  while ((match = urlRegex.exec(processedText)) !== null) {
    const url = match[0];
    // Check if the URL is already part of another entity
    const overlaps = entities.some(
      (entity) =>
        (match!.index >= entity.start && match!.index < entity.end) ||
        (match!.index + url.length > entity.start && match!.index < entity.end),
    );

    if (!overlaps) {
      const displayUrl = url.replace(/^https?:\/\//, "");
      entities.push({
        start: match!.index,
        end: match!.index + url.length,
        replacement: generateLinks
          ? `<a href="${url}" class="text-purple hover:underline" target="_blank" rel="noopener noreferrer">${displayUrl}</a>`
          : `<span class="text-purple" title="${url}">${displayUrl}</span>`,
      });
    }
  }

  // Mentions
  const mentionRegex = /(@\w+)(?![^<]*>)/g;
  match = null;
  while ((match = mentionRegex.exec(processedText)) !== null) {
    const mention = match[0];
    const username = mention.substring(1); // Remove the @ symbol

    // Check for overlaps with existing entities
    const overlaps = entities.some(
      (entity) =>
        (match!.index >= entity.start && match!.index < entity.end) ||
        (match!.index + mention.length > entity.start &&
          match!.index < entity.end),
    );

    if (!overlaps) {
      entities.push({
        start: match!.index,
        end: match!.index + mention.length,
        replacement: generateLinks
          ? `<a href="https://x.com/${username}" class="text-purple hover:underline" target="_blank" rel="noopener noreferrer">${mention}</a>`
          : `<span class="text-purple" title="https://x.com/${username}">${mention}</span>`,
      });
    }
  }

  // Hashtags
  const hashtagRegex = /#(\w+)(?![^<]*>)/g;
  match = null;
  while ((match = hashtagRegex.exec(processedText)) !== null) {
    const hashtag = match[0];
    const tag = match[1]; // Capture group without the # symbol

    // Check for overlaps
    const overlaps = entities.some(
      (entity) =>
        (match!.index >= entity.start && match!.index < entity.end) ||
        (match!.index + hashtag.length > entity.start &&
          match!.index < entity.end),
    );

    if (!overlaps) {
      entities.push({
        start: match!.index,
        end: match!.index + hashtag.length,
        replacement: generateLinks
          ? `<a href="https://x.com/search?q=%23${tag}" class="text-purple hover:underline" target="_blank" rel="noopener noreferrer">${hashtag}</a>`
          : `<span class="text-purple" title="https://x.com/search?q=%23${tag}">${hashtag}</span>`,
      });
    }
  }

  // Cashtags
  const cashtagRegex = /\$(\w+)(?![^<]*>)/g;
  match = null;
  while ((match = cashtagRegex.exec(processedText)) !== null) {
    const cashtag = match[0];
    const tag = match[1]; // Capture group without the $ symbol

    // Check for overlaps
    const overlaps = entities.some(
      (entity) =>
        (match!.index >= entity.start && match!.index < entity.end) ||
        (match!.index + cashtag.length > entity.start &&
          match!.index < entity.end),
    );

    if (!overlaps) {
      entities.push({
        start: match!.index,
        end: match!.index + cashtag.length,
        replacement: generateLinks
          ? `<a href="https://x.com/search?q=%24${tag}" class="text-purple hover:underline" target="_blank" rel="noopener noreferrer">&dollar;${tag}</a>`
          : `<span class="text-purple" title="https://x.com/search?q=%24${tag}">&dollar;${tag}</span>`,
      });
    }
  }

  // Sort entities by start position in reverse order to avoid index shifting
  entities.sort((a, b) => b.start - a.start);

  // Apply replacements
  let result = processedText;
  for (const entity of entities) {
    result =
      result.substring(0, entity.start) +
      entity.replacement +
      result.substring(entity.end);
  }

  return result;
}
